import React from 'react';
import { useSelector } from 'react-redux';
import propTypes from 'prop-types';
import { userStatusSelector } from 'redux/reducers/userStatus';
import Forbidden from 'components/Forbidden';
import NotAuthenticated from 'components/NotAuthenticated';

const UserStatusHandler = ({ children }) => {
  const { isAuthorized, isAuthenticated } = useSelector(userStatusSelector);

  if (!isAuthenticated) {
    return <NotAuthenticated />;
  }

  if (!isAuthorized) {
    return <Forbidden />;
  }

  // NOTE: Faux positif répertorié ici: https://github.com/yannickcr/eslint-plugin-react/issues/2584
  // eslint-disable-next-line react/jsx-no-useless-fragment
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

UserStatusHandler.propTypes = {
  children: propTypes.node.isRequired,
};

export default UserStatusHandler;
